import { DrawCleavageEvent } from '../events/drawCleavage/DrawCleavageEvent';
import { UseCase } from './UseCase';
export class StartAutoplayUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.autoplay.configureNextAutoPlay(event.autoplayMinutes)
            .then(() => this.applicationServices.interface.enableAutoplay())
            .then(() => this.applicationServices.event.sentEvent(new DrawCleavageEvent()))
            .catch(error => Promise.reject(error));
    }
}
